import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import pathfinder from '@fiverr-private/pathfinder';
import { sendMixpanelTrackEvent } from '../../../../lib/mixpanel';
import { REGISTRATION_BUTTON_CLICK } from '../../../../lib/mixpanel/constants';

export const JoinButton = () => {
    const { isTouch } = getContext();

    const path = pathfinder('join', {}, { query: { source: 'tag_page_header' } });

    const onClick = (event) => {
        event.preventDefault();

        sendMixpanelTrackEvent({ eventName: REGISTRATION_BUTTON_CLICK });
    };

    return (
        <Button
            href={path}
            rel="nofollow"
            className="js-open-popup-join"
            size={isTouch ? 'sm' : 'md'}
            colorScheme="green"
            onClick={onClick}
        >
            <I18n k="tag_page_perseus.header.join" />
        </Button>
    );
};
